var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.167 1.583)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4884E8",
    d: "M4.6 5.405 7.758 0h4.585L9.185 5.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BA3FF",
    d: "m0 0 3.157 5.405h4.585L4.585 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD164",
    cx: 6.171,
    cy: 10.008,
    r: 5.825
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE17D",
    cx: 6.171,
    cy: 10.008,
    r: 4.604
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD164",
    cx: 6.171,
    cy: 10.008,
    r: 3.485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96 11.875V7.919h-.687L5 8.934l.406.503.454-.365c.027-.022.055-.046.084-.073a7.572 7.572 0 0 0 .203-.2 27.685 27.685 0 0 1-.015.412 8.49 8.49 0 0 0-.006.375v2.289h.836z",
    fill: "#A66400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalGold);
export default __webpack_public_path__ + "static/media/medal-gold.858f330f.svg";
export { ForwardRef as ReactComponent };